var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coinflow-i-frame',{attrs:{"args":Object.assign({}, _vm.iframeProps, _vm.messageHandlers)}})}
var staticRenderFns = []

export { render, staticRenderFns }